import axios from 'axios';
// import moment from "moment";
// import {downloadFile} from "@/helpers/helpers";
import {getField, updateField} from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        returns: [],
        products: [],
        reasons: [],
        order: null,
    }
}

export const state = getDefaultState();

export const getters = {
    all: (state) => state.all,
    roleName: (state) => {
        let name = ''
        if (state.user?.role !== null) {
            name = state.user?.role.name
        }
        return name;
    },
    getField
}

export const actions = {
    async fetchReturns({commit}) {
        const response = await axios.post(`/fastmarket/account/return`);
        commit('SET_RETURNS', response.data.returns.data);
        commit('SET_PRODUCTS', response.data.products);
        commit('SET_REASONS', response.data.reasons);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async add({commit,state}, data) {
        let pp = [];
        state.products.forEach(p => { if(p.quantity_return > 0 ) pp.push(p) })
        data.products = pp
        const response = await axios.post(`/fastmarket/account/return/add`, data);
        return response.data.success
    },
}

export const mutations = {
    updateField,
    SET_RETURNS(state, result) {
        state.returns =  result
    },
    SET_PRODUCTS(state, result) {
        state.products = result
    },
    SET_REASONS(state, result) {
        state.reasons = result
    },
    SET_ORDER(state, result) {
        state.order = result
    },
}